<button matRipple (click)="openReportingDialog()" class="button" [title]="buttonTitle | translate">
  {{ 'page.detail.buttons.title_report' | translate }}
</button>
